<template lang="html">
  <div id="article-page">

    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000" v-if="!isLoading">
      <div class="row">
        <div class="col-lg-7 mt-3 mt-lg-0 col-content">
          <div class="mb-2">
            <h1 class="title-s1">{{ blog.name }}</h1>
          </div>

          <div class="box-content" v-html="blog.body"></div>
        </div>

        <div class="col-lg-5 col-image">
          <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+blog.image+')' }" v-if="blog.image">
            <img src="public/images/shared/empty.png">
          </div>
        </div>
      </div>
    </section>

    <LoadingComponent v-else></LoadingComponent>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {LoadingComponent},

  data() {
    return {
      isLoading: true,
      id: null,

      blog: {},
    }
  },

  methods: {
    getArticle() {
      this.isLoading = true;
      axios.get(tools.url('/api/blog/'+this.id)).then((response) =>{
        this.blog = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  mounted() {
    this.id = this.$root._getURLID(this.$route.params.id);    
    this.getArticle();
  }
}
</script>
